module.exports = __webpack_public_path__ + "img/tape-logo-typo.70d79b7c.png";